/*
 *
 * Users Actions
 *
 * @version 1.0.0
 * @author Vittorio Scaperrotta
 * @since 13-Dec-2022
 */

import { createRequestTypes, createAction, MakeRequest } from 'Store/actions/index';

export const actionTypes = {
	DO_SET_ITEM_TO_SHOW_DETAIL: '@@Users/set_item_to_show_detail',
	DO_RESET_ERROR: '@@Users/reset_error',
	// @generator action:route:type
	...createRequestTypes('@@Users', 'FETCH_BACKOFFICE_USER_LIST'),
	...createRequestTypes('@@Users', 'FETCH_BACKOFFICE_USER_FIND'),
	...createRequestTypes('@@Users', 'BACKOFFICE_USER_DELETE'),
	...createRequestTypes('@@Users', 'FETCH_BACKOFFICE_USER_DETAIL'),
	...createRequestTypes('@@Users', 'CREATE_BACK_OFFICE_USER'),
	...createRequestTypes('@@Users', 'UPDATE_BACK_OFFICE_USER'),
	...createRequestTypes('@@Users', 'CREATE_BACKOFFICE_USER_ROLE'),
	// @generator action:route:type:request
};

// ------------------------------------
// Actions
// ------------------------------------

/** @action request
 * * Insert a description
 * @name createBackofficeUserRole
 * @return {object} - The action object
 */
export const createBackofficeUserRole = new MakeRequest('Users', 'create_backoffice_user_role');
/** @action request
 * * Insert a description
 * @name updateBackOfficeUser
 * @return {object} - The action object
 */
export const updateBackOfficeUser = new MakeRequest('Users', 'update_back_office_user');
/** @action request
 * * Insert a description
 * @name createBackOfficeUser
 * @return {object} - The action object
 */
export const createBackOfficeUser = new MakeRequest('Users', 'create_back_office_user');
/** @action request
 * * Insert a description
 * @name fetchBackofficeUserDetail
 * @return {object} - The action object
 */
export const fetchBackofficeUserDetail = new MakeRequest('Users', 'fetch_backoffice_user_detail');
/** @action request
 * * Insert a description
 * @name backofficeUserDelete
 * @return {object} - The action object
 */
export const backofficeUserDelete = new MakeRequest('Users', 'backoffice_user_delete');
/** @action request
 * * Insert a description
 * @name fetchBackofficeUserFind
 * @return {object} - The action object
 */
export const fetchBackofficeUserFind = new MakeRequest('Users', 'fetch_backoffice_user_find');
/** @action request
 * * Insert a description
 * @name fetchBackofficeUserList
 * @return {object} - The action object
 */
export const fetchBackofficeUserList = new MakeRequest('Users', 'fetch_backoffice_user_list');

// @generator action:route:request
/** @action
 * * Insert a description
 * @name ResetError
 * @return {object} - The payload object
 */
export const doResetError = (payload) => createAction(actionTypes.DO_RESET_ERROR, { payload });
/** @action
 * * Insert a description
 * @name SetItemToShowDetail
 * @return {object} - The payload object
 */
export const doSetItemToShowDetail = (payload) => createAction(actionTypes.DO_SET_ITEM_TO_SHOW_DETAIL, { payload });

// @generator action:route
